import { ReportCallback } from 'web-vitals';
import ReactGA from 'react-ga4';

const reportWebVitals = (onPerfEntry?: ReportCallback): void => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

// the analytics event
interface Event {
  id: string;
  name: string;
  value: number;
}

/**
 * send the information to the analytics engine
 * @param e event
 */
const sendToAnalytics = ({ id, name, value }: Event): void => {
  ReactGA.event({
    category: 'Web Vitals',
    action: name,
    value: Math.round(name === 'CLS' ? value * 1000 : value), // values must be integers
    label: id, // id unique to current page load
    nonInteraction: true, // avoids affecting bounce rate
    // Use `sendBeacon()` if the browser supports it.
    transport: 'beacon'
  });
};

// initialize tracking
const trackingId = process.env.REACT_APP_TRACKINGID as string; // Replace with your Google Analytics tracking ID
if (trackingId) {
  ReactGA.initialize(trackingId, { gaOptions: { storage: 'none', storeGac: false, cookieFlags: 'SameSite=None; Secure' } });
}

export { sendToAnalytics, reportWebVitals };
